import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-data-list',
  templateUrl: './user-data-list.component.html',
  styleUrls: ['./user-data-list.component.css']
})
export class UserDataListComponent implements OnInit {
  userType;
  menuList;
  allowedComponents = new Set<string>();
  constructor(private router:Router) { }

  ngOnInit(): void {
    this.userType=localStorage.getItem('userType');
    this.menuList = JSON.parse(localStorage.getItem('menuList'));
    this.menuList.forEach(menu => {
    menu.menu?.menuComponents?.forEach(component => {
      this.allowedComponents.add(component.name);
    });
  });
  }

  hasAccess(componentName: string): boolean {
  return this.allowedComponents.has(componentName);
}

  myLeavesClick(){
    this.router.navigate(['dashboard/my-leaves']);
  }

  myHolidaysClick(){
    this.router.navigate(['dashboard/my-holidays-report']);
  }

  personalDetailsClick(){
    this.router.navigate(['dashboard/personal-details']);
  }

  officialDetailsClick(){
    this.router.navigate(['dashboard/official-details']);
  }

  CTCDetailsClick(){
    this.router.navigate(['dashboard/ctc-details']);
  }

  exitFormClick(){
    this.router.navigate(['dashboard/exit-form']);
  }

  knowYourColleaguesClick(){
    this.router.navigate(['dashboard/know-your-colleauge']);
  }

  knowYourClientsClick(){
    this.router.navigate(['dashboard/know-your-clients']);
  }
}
